import React, { useState } from 'react'
import { Button } from '~/components/_atoms'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '~/lib/ui/dialog'
import { useTranslation } from '~/hooks/useTranslation'
import { apiGet } from '~/util/api'
import { useToast } from '~/lib/ui/toast'

const EmailSignUpModal = ({ linkText, hasLiveEventsNotifications }) => {
  const [open, setOpen] = useState(false)
  const { t } = useTranslation()
  const { toast } = useToast()

  const toggleOpen = () => {
    setOpen(!open)
  }

  const signUp = async () => {
    try {
      await apiGet('/coach_services/sign_up_for_webinar_alerts')
      toast({
        title: t('email_sign_up_modal.success_title'),
        description: t('email_sign_up_modal.success_description'),
        duration: 10_000,
      })
    } catch (error) {
      toast({
        title: t('email_sign_up_modal.error_title'),
        description: t('email_sign_up_modal.error_description'),
        variant: 'destructive',
        duration: 10_000,
      })
      console.log('Error signing up for webinar alerts:', error)
    }
    setOpen(false)
  }

  return (
    <Dialog open={open} onOpenChange={toggleOpen} className="rounded-2xl">
      <DialogTrigger asChild className="cursor-pointer">
        <Button
          component="button"
          variant="link"
          color="secondary"
          className="px-0 py-0"
        >
          {linkText || t('email_sign_up_modal.link_text')}
        </Button>
      </DialogTrigger>

      <DialogContent
        className="fix-legacy-hack font-roboto lg:max-w-3xl"
        variant="default"
        dialogCloseClass="text-black"
      >
        <DialogHeader>
          <DialogTitle className="text-left" asChild>
            <h2 className="text-2xl">{t('email_sign_up_modal.notify_me')}</h2>
          </DialogTitle>
        </DialogHeader>

        <div className="px-4 pb-4">
          <div className="mb-4">
            {hasLiveEventsNotifications ? (
              <p>{t('email_sign_up_modal.already_subscribed')}</p>
            ) : (
              <p>{t('email_sign_up_modal.description')}</p>
            )}
            <p>{t('email_sign_up_modal.change_settings')}</p>
            <div className="flex flex-row justify-end">
              {!hasLiveEventsNotifications && (
                <Button variant="solid" color="primary" onClick={signUp}>
                  {t('email_sign_up_modal.send_me_alerts')}
                </Button>
              )}
              <Button
                variant="link"
                color="primary"
                onClick={toggleOpen}
                className="ml-2"
              >
                {t('email_sign_up_modal.cancel')}
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default EmailSignUpModal
